/* eslint-disable no-unused-vars */
import $ from 'jquery';


( function($) {
	
	document.addEventListener("DOMContentLoaded", function()
	{
		console.log('ready 4');
		setupTabsSliders();
	});


	/**
	 * Initialize sliders with tabs navigation (single-programme page)
	 * 
	 * @return void
	 */
	function setupTabsSliders()
	{
		let $slider = $('.slider-tabs .slider-content').slick({
			slidesToScroll: 1,
			speed: 1000,
			cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
			draggable: true,
			swipe: true,
			arrows: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="slick-prev"></button>',
			nextArrow: '<button type="button" class="slick-next"></button>',
		});

		let $slides = $slider.find(".slick-slide");
		$slides.height("auto");
		$slider.slick("setOption", null, null, true);

		$slides.find('.nav-btn.prev').on('click', function() { $slider.slick('slickPrev'); });
		$slides.find('.nav-btn.next').on('click', function() { $slider.slick('slickNext'); });

		let collapses = $('.slider-tabs .slider-content .collapse');
		let intervalID;

		// Adapts the slider height if collapsable content is toggled
		$(collapses).each(function(e) {
			this.addEventListener('show.bs.collapse', function(event){
				let target = this;
				// Dirty way to animate the slider height
				intervalID = setInterval(function() {
					updateSliderHeight(target);
				}, 10);
			});

			this.addEventListener('shown.bs.collapse', function(event){
				updateSliderHeight(this, true);
				clearInterval(intervalID);
			});

			this.addEventListener('hidden.bs.collapse', function(event){
				updateSliderHeight(this, false);
			});
		}); 


		/**
		 * Adapt the slider height based on current slide height
		 * 
		 * @param DomElement children A children of the current slide
		 * @param boolean open	True if the slider is currently opening
		 * 
		 * @return [type]
		 */
		function updateSliderHeight(children, open)
		{
			let slide = $(children).parents('.slick-slide')[0];
			let list = $(children).parents('.slick-list')[0];
			let newHeight = (open) ? $(slide).outerHeight() : $(slide).height();

			$(list).css('height', newHeight+'px');
		}

		// Update active tab button display (tabs buttons must be in the slide order)
		$('.slider-tabs').on('beforeChange', function(event, slick, currentSlide, nextSlide)
		{
			let tabs = $(this).find('.tabs');

			$(tabs).find('[data-target]').removeClass('active');
			$(tabs).find('[data-target]').eq(nextSlide).addClass('active');
			console.log('Before change : '+currentSlide+' > '+nextSlide, tabs);
		});

		$('.slider-tabs').on('afterChange', function(event, slick, currentSlide)
		{
			let tabs = $(this).find('.tabs');

			$(tabs).find('[data-target]').removeClass('active');
			$(tabs).find('[data-target]').eq(currentSlide).addClass('active');
			console.log('After change : '+currentSlide, tabs);
		});

		//
		$('.slider-tabs .tabs [data-target]').on('click', function() {
			let target = $(this).data('target');
			let tabs = $(this).parents('.tabs');
			let slider = $(tabs[0]).siblings('.slider-content');

			$(slider).slick('slickGoTo', $(this).index());
		});
	}

})(jQuery);